import { useAppDispatch, useAppSelector } from '@/core/global-store';
import { logout } from '@/core/global-store/features/auth/authSlice';
import Logo from '@repo/ui/components/icons/Logo';
import { LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Header() {
    const user = useAppSelector((s) => s.auth.me);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const handleLogout = () => {
        dispatch(logout());
        navigate('/login');
    };

    return (
        <header className="flex h-16 flex-row items-center justify-between bg-primery-blue-500 py-4">
            <div className='px-3 w-full max-w-[1240px] mx-auto flex flex-row justify-between items-center'>
                <div className="flex flex-col items-end justify-end text-[#ffffff] text-[23px] font-semibold" >
                    Clinico
                    <div className='flex flex-row items-center justify-center gap-2'>

                        <button
                            type="button"
                            onClick={handleLogout}
                            className="flex items-center justify-center rounded text-white transition-colors hover:bg-white/15 focus:outline-none focus:ring-2 focus:ring-white/30"
                            aria-label="تسجيل الخروج"
                        >
                            <LogOut className="h-3 w-3" />
                        </button>
                        <span className="text-[12px] font-medium leading-tight text-primery-blue-100">
                            مرحبا بك  {user?.data?.name ?? '—'}
                        </span>

                    </div>
                </div>

                <div className="flex flex-row items-center gap-4">

                    <span className="cursor-pointer" onClick={() => navigate('/')}>
                        <Logo width="70" height="40" className="text-white" />
                    </span>
                </div>
            </div>
        </header>
    );
}
